var _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGlobe(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_47_2610)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18 2V2C9.16344 2 2 9.16344 2 18V18",
    stroke: props.color,
    strokeWidth: 3,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18 62V62C9.16344 62 2 54.8366 2 46V46",
    stroke: props.color,
    strokeWidth: 3,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46 2V2C54.8366 2 62 9.16344 62 18V18",
    stroke: props.color,
    strokeWidth: 3,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46 62V62C54.8366 62 62 54.8366 62 46V46",
    stroke: props.color,
    strokeWidth: 3,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 32,
    cy: 32,
    r: 18.25,
    stroke: props.color,
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.25 32C42.25 37.1387 41.0425 41.7542 39.1291 45.0592C37.2044 48.3837 34.6572 50.25 32 50.25C29.3428 50.25 26.7956 48.3837 24.8709 45.0592C22.9575 41.7542 21.75 37.1387 21.75 32C21.75 26.8613 22.9575 22.2458 24.8709 18.9407C26.7956 15.6163 29.3428 13.75 32 13.75C34.6572 13.75 37.2044 15.6163 39.1291 18.9407C41.0425 22.2458 42.25 26.8613 42.25 32Z",
    stroke: props.color,
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 31.75,
    y1: 14,
    x2: 31.75,
    y2: 50,
    stroke: props.color,
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 13,
    y1: 32.25,
    x2: 50,
    y2: 32.25,
    stroke: props.color,
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 16,
    y1: 23.25,
    x2: 48,
    y2: 23.25,
    stroke: props.color,
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 16,
    y1: 41.25,
    x2: 48,
    y2: 41.25,
    stroke: props.color,
    strokeWidth: 1.5
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_47_2610"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 64,
    height: 64,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGlobe);
export default __webpack_public_path__ + "static/media/Globe.2d79a237d784c9c0a2510b07a3b35bb8.svg";
export { ForwardRef as ReactComponent };